import React from "react";

export type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export interface HeadingProps {
  type: HeadingType;
  text?: string;
  className?: string;
  children?: JSX.Element | JSX.Element[];
}

export const Heading = ({
  type,
  text,
  children,
  className: classNames,
}: HeadingProps) => {
  const CustomHeading = `${type}` as keyof JSX.IntrinsicElements;

  return <CustomHeading className={`${classNames}`}>
      {children ? children : null}
      {text ? text : null}
    </CustomHeading>;
};
